import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import Radiobutton from '#components/a/form/Radio'

const SORT_ASC = 'aufsteigend'
const SORT_DESC = 'absteigend'

function SortingDialog({sortOptions, addFilterOption, type}) {
  const isSortedByCurrentType = sortOptions.filterType === type
  const currentTypeSortASC = isSortedByCurrentType && sortOptions.sortType === SORT_ASC
  const currentTypeSortDESC = isSortedByCurrentType && sortOptions.sortType === SORT_DESC

  const setAscending = () => {
    addFilterOption({sortType: SORT_ASC, filterType: type})
  }

  const setDescending = () => {
    addFilterOption({sortType: SORT_DESC, filterType: type})
  }

  return (
    <div className="filter__ASC__DESC">
      <div>
        <Radiobutton labelText="Aufsteigend" checked={currentTypeSortASC} onChangeHandle={setAscending} />
        <span>(A-Z, 0-99)</span>
      </div>
      <div>
        <Radiobutton labelText="Absteigend" checked={currentTypeSortDESC} onChangeHandle={setDescending} />
        <span>(Z-A, 99-0)</span>
      </div>
    </div>
  )
}

SortingDialog.propTypes = {
  type: PropTypes.string.isRequired,
  addFilterOption: PropTypes.func.isRequired,
  sortOptions: PropTypes.object.isRequired,
}

const mapDispatchToProps = () => ({
  addFilterOption: actions.meineAzubis.addFilterOption,
})

export default connect(mapDispatchToProps)(SortingDialog)
